import { Button, Form, Input } from "antd";

export function SendOtpForm({ form, loading, onSubmit }) {
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={(values) => onSubmit?.(values)}
      autoComplete="off"
    >
      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true, message: "Vui lòng nhập email!" },
          { type: "email", message: "Email không hợp lệ!" },
        ]}
      >
        <Input placeholder="Nhập email" size="large" />
      </Form.Item>

      <Form.Item>
        <Button
          size="large"
          type="primary"
          htmlType="submit"
          loading={loading}
          block
        >
          {loading ? "Đang gửi..." : "Nhận mã xác thực"}
        </Button>
      </Form.Item>
    </Form>
  );
}
